import React from 'react';
import styles from './LoginButton.module.css';

const LoginButton = ({ text, onClick, type, disabled}) => {
  return (
    <button 
    className={styles['login-button']} 
    onClick={onClick}
    type={type}
    disabled={disabled}> 
      {text}
    </button>
  );
};

export default LoginButton;
